import React, { useRef, useState } from 'react';
import './_select-icon.scss';
import './_select-icon.dark-mode.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SelectIconUpload from './Upload';
import SelectIconIcons from './Icons';
import SelectIconEmoji from './Emoji';
import Preview from './Preview';
import { ICON_TYPES, tabs } from './constants';

const SelectIcon = ({ modal, types, icon, extensions, onChange }) => {
  const selectNode = useRef()
  const previewRef = useRef()

  const [isOpenPopup, setOpenPopup] = useState(false);
  const [activeTab, setActiveTab] = useState(icon?.icon_type ? icon.icon_type : ICON_TYPES.ICON);
  const onChangeTab = (value) => {
    setActiveTab(value);
  };

  const onKeyEnter = (event) => {
    if (event.keyCode === 13) {
      document.removeEventListener('keydown', onKeyEnter, false);
      setOpenPopup(false);
    }
  };

  const outSideClickIcons = (e) => {
    if (selectNode.current && selectNode.current.contains(e.target)) {
      return false;
    }
    if (previewRef.current && previewRef.current.contains(e.target)) {
      return false;
    }

    document.removeEventListener('mousedown', outSideClickIcons, false);
    document.removeEventListener('keydown', onKeyEnter, false);
    return setOpenPopup(false);
  };

  const onChangePopup = () => {
    document.addEventListener('mousedown', outSideClickIcons, false);
    document.addEventListener('keydown', onKeyEnter, false);
    setOpenPopup(!isOpenPopup)
  }

  const onRemoveIcon = (e) => {
    e.preventDefault()
    onChange(null)
  }

  return (
    <div className="select-icon">
      <div
        className="select-icon__preview"
        ref={previewRef}
        onClick={onChangePopup}
      >
        <Preview
          icon={icon}
        />
      </div>
      {isOpenPopup
        ? (
          <div className="select-icon__popup" ref={selectNode}>
            <div className="select-icon__popup-header">
              <div className="select-icon__tabs">
                {tabs
                  .filter((tab) => types.includes(tab.icon_type))
                  .map((tab) => (
                    <div
                      className={classNames('select-icon__tabs-item', {
                        active: activeTab === tab.icon_type,
                      })}
                      key={tab.icon_type}
                      onClick={() => onChangeTab(tab.icon_type)}
                    >
                      <div className="select-icon__tabs-item-icon">
                        {tab.icon}
                      </div>
                      <div className="select-icon__tabs-item-description">{tab.name}</div>
                    </div>
                  ))}
              </div>
              {icon
                ? (
                  <div className="select-icon__popup-header-remove">
                    <a href="#remove" onClick={onRemoveIcon}>Remove</a>
                  </div>
                ) : null}
            </div>
            <div className="select-icon__popup-body">
              {(() => {
                switch (activeTab) {
                case ICON_TYPES.ICON:
                  return (
                    <SelectIconIcons
                      onChange={onChange}
                      value={icon?.icon}
                    />
                  )
                case ICON_TYPES.EMOJI:
                  return (
                    <SelectIconEmoji
                      onChange={onChange}
                      value={icon?.icon}
                    />
                  )
                case ICON_TYPES.IMAGE:
                  return (
                    <SelectIconUpload
                      extensions={extensions}
                      categoryId={modal?.id}
                      selectedIcon={icon}
                      onChange={onChange}
                    />
                  )
                default:
                  return null;
                }
              })()}
            </div>
          </div>
        ) : null}
    </div>
  )
}

SelectIcon.propTypes = {
  icon: PropTypes.object,
  types: PropTypes.array,
  modal: PropTypes.object,
  extensions: PropTypes.array,
  onChange: PropTypes.func,
};
export default SelectIcon;
